import {
    extractProperties,
    isEmpty,
} from './'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatSessionStatusUpdatedEvent} from '../types/events'
import {NinchatState} from 'api/types'

export const sessionStatusUpdated: CaseReducer<NinchatState> = (state, action) => {
    const {
        channel_id,
        message_id,
        user_id,
        ...rest
    } = extractProperties<NinchatSessionStatusUpdatedEvent>(action.payload)

    isEmpty(rest)

    if (channel_id) {
        state.user_channels[channel_id].channel_status = undefined
        state.user_channels[channel_id].seen_message_id = message_id
    }

    if (user_id) {
        state.user_dialogues[user_id].dialogue_status = undefined
    }
}
